import React from 'react';
import {Modal, SafeAreaView, StyleSheet, View} from 'react-native';
import {ActivityIndicator, Button, Dialog, Portal, Snackbar, Text} from 'react-native-paper';
import {useAppSelector, useAppDispatch} from '../store/hooks';
import {showErrorMessage, showToastMessage} from '../store/slices/alertsSlice';
import Colors from "../resources/Colors";

const Alerts = (): React.JSX.Element => {
  const alerts = useAppSelector(state => state.alerts);
  const dispatch = useAppDispatch();

  return (
    <SafeAreaView>
      <Modal visible={alerts.showLoading} transparent={true}>
        <View style={style.container}>
          <ActivityIndicator size="large"/>
          <Text style={style.message}>{alerts.loadingMessage}</Text>
        </View>
      </Modal>

      <Modal visible={alerts.showLoadingChat} transparent={true}>
        <View style={style.container}>
          <ActivityIndicator size="large"/>
          <Text style={style.message}>{alerts.loadingMessage}</Text>
        </View>
      </Modal>

      <Portal>
        <Dialog visible={alerts.showErrorDialog} onDismiss={() => {
        }}>
          <Dialog.Title>Error</Dialog.Title>
          <Dialog.Content>
            <Text variant="bodyMedium">{alerts.errorMessage}</Text>
          </Dialog.Content>
          <Dialog.Actions>
            <Button
              onPress={() => {
                dispatch(showErrorMessage(''));
              }}>
              Done
            </Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <Snackbar
        visible={alerts.showToast}
        onDismiss={() => {
          dispatch((showToastMessage("")))
        }}
        action={{
          label: 'hide',
          onPress: () => {

          },
        }}
        rippleColor={Colors.greenButtonColor}
        style={{backgroundColor: Colors.bgBlue}}
        duration={2500}
      >
        {alerts.toastMessage}
      </Snackbar>
    </SafeAreaView>
  );
};

export default Alerts;

const style = StyleSheet.create({
  message: {
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'center',
    color: '#ffffff',
    marginTop: 20,
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#00000090',
  },
});
